import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * ThreadsEmbed - Organism
 * Componente completo para embed de posts do Threads
 * Segue Atomic Design (baseado no InstagramEmbed)
 */
const ThreadsEmbed = ({ article, isOpen, sx = {} }) => {
    const containerRef = React.useRef(null);

    // Carregar script do Threads
    useEffect(() => {
        // Verificar se o script já está carregado
        const existingScript = document.querySelector('script[src="https://www.threads.net/embed.js"]');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://www.threads.net/embed.js';
            script.async = true;
            script.onload = () => {
                console.log('✅ Script do Threads carregado com sucesso');
            };
            script.onerror = () => {
                console.error('❌ Erro ao carregar script do Threads');
            };
            document.body.appendChild(script);
            console.log('📜 Adicionando script do Threads...');
        } else {
            console.log('📜 Script do Threads já existe');
        }
    }, []);

    // Processar embed quando artigo mudar
    useEffect(() => {
        if (!article || article.mediaType !== 'Threads' || !article.embedCode) {
            return;
        }

        if (!isOpen) return;

        console.log('🧵 Processando embed do Threads...');

        // Função para processar com verificação de DOM
        const processEmbed = (attempt) => {
            if (!containerRef.current) {
                console.warn(`⚠️ Container não encontrado (tentativa ${attempt})`);
                return;
            }

            const blockquote = containerRef.current.querySelector('.text-post-media');

            if (!blockquote) {
                console.warn(`⚠️ Blockquote não encontrado no DOM (tentativa ${attempt})`);
                return;
            }

            if (window.instgrm && window.instgrm.Embeds) {
                console.log(`🔄 Processando embeds do Threads (tentativa ${attempt})...`);
                console.log(`   - Blockquote encontrado:`, blockquote);
                console.log(`   - Atributos:`, {
                    permalink: blockquote.getAttribute('data-text-post-permalink'),
                    version: blockquote.getAttribute('data-text-post-version'),
                    class: blockquote.className
                });
                // Processar o blockquote específico
                window.instgrm.Embeds.process(containerRef.current);
            } else {
                console.warn(`⚠️ window.instgrm não disponível (tentativa ${attempt})`);
            }
        };

        // Tentar processar múltiplas vezes com delays crescentes
        const timeout1 = setTimeout(() => processEmbed(1), 300);
        const timeout2 = setTimeout(() => processEmbed(2), 800);
        const timeout3 = setTimeout(() => processEmbed(3), 1500);
        const timeout4 = setTimeout(() => processEmbed(4), 3000);

        return () => {
            clearTimeout(timeout1);
            clearTimeout(timeout2);
            clearTimeout(timeout3);
            clearTimeout(timeout4);
        };
    }, [article, isOpen]);

    // Não renderizar embed se não for Threads ou não tiver embedCode
    const isThreads = article?.mediaType === 'Threads' && article?.embedCode;

    if (!isThreads) return null;

    // Remover script tag do embedCode (já carregamos separadamente)
    const cleanEmbedCode = article.embedCode.replace(/<script[^>]*>.*?<\/script>/gi, '');

    return (
        <Box
            ref={containerRef}
            className="threads-embed-container"
            sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'center',
                ...sx
            }}
            dangerouslySetInnerHTML={{ __html: cleanEmbedCode }}
        />
    );
};

ThreadsEmbed.propTypes = {
    article: PropTypes.object,
    isOpen: PropTypes.bool,
    sx: PropTypes.object
};

export default ThreadsEmbed;
